(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.c-bundle-builder');

    const toCurrency = (value) => {
      const amount = Number(value || 0) / 100;
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$ ' + formatter.format(amount);
    };

    const getSidebarMedia = (item) => {
      if (item.image && item.image.length) {
        return `<img class="c-bundle-builder__selected-image" src="${item.image}" alt="${item.title}">`;
      }
      return '<span class="c-bundle-builder__empty-image" aria-hidden="true">+</span>';
    };

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const maxItems = Number(section.dataset.maxItems || 10);
      const tabs = Array.from(section.querySelectorAll('[data-bundle-tab]'));
      const productNodes = Array.from(section.querySelectorAll('[data-bundle-product]'));
      const swiperElement = section.querySelector('[data-products-swiper]');
      const swiperWrapper = swiperElement?.querySelector('.swiper-wrapper');
      const selectedList = section.querySelector('[data-selected-list]');
      const emptyList = section.querySelector('[data-empty-list]');
      const selectedCountNode = section.querySelector('[data-selected-count]');
      const progressPercentNode = section.querySelector('[data-progress-percent]');
      const progressFill = section.querySelector('[data-progress-fill]');
      const addAllButton = section.querySelector('[data-add-all]');
      const paginationElement = section.querySelector('[data-products-pagination]');
      const prevElement = section.querySelector('[data-products-prev]');
      const nextElement = section.querySelector('[data-products-next]');

      let activeTab = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.tabTag || tabs[0]?.dataset.tabTag || '';
      let swiper = null;
      let resizeTimeout = null;
      const selected = new Map();
      const productsByTab = new Map();
      const tabIndexByCollection = new Map();

      productNodes.forEach((node) => {
        const tag = node.dataset.tabTag || '';
        if (!productsByTab.has(tag)) {
          productsByTab.set(tag, []);
        }
        productsByTab.get(tag).push(node);
      });

      const getSelectedUnits = () => {
        let total = 0;
        selected.forEach((item) => {
          total += item.quantity;
        });
        return total;
      };

      const canIncrease = () => getSelectedUnits() < maxItems;

      const renderActiveSlides = () => {
        if (!swiperWrapper) return;
        const activeSlides = productsByTab.get(activeTab) || [];
        swiperWrapper.innerHTML = '';
        activeSlides.forEach((slide) => {
          slide.hidden = false;
          slide.setAttribute('aria-hidden', 'false');
          swiperWrapper.appendChild(slide);
        });
      };

      const updateCardState = () => {
        productNodes.forEach((node) => {
          const variantId = node.dataset.variantId;
          const addButton = node.querySelector('[data-action="add"]');
          const qtyControl = node.querySelector('[data-qty-control]');
          const qtyValue = node.querySelector('[data-qty-value]');
          const selectedItem = selected.get(variantId);

          if (!addButton || !qtyControl || !qtyValue) return;

          if (selectedItem && selectedItem.quantity > 0) {
            addButton.hidden = true;
            qtyControl.hidden = false;
            qtyValue.textContent = String(selectedItem.quantity);
          } else {
            addButton.hidden = false;
            qtyControl.hidden = true;
            qtyValue.textContent = '1';
          }
        });
      };

      const renderSidebar = () => {
        if (!selectedList || !emptyList || !selectedCountNode || !progressPercentNode || !progressFill || !addAllButton) return;

        selectedList.innerHTML = '';
        emptyList.innerHTML = '';

        const selectedEntries = Array.from(selected.values());
        const selectedUnits = getSelectedUnits();
        const selectedRows = selectedEntries.length;

        selectedEntries.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'c-bundle-builder__selected-item';
          row.innerHTML = `
            <div class="c-bundle-builder__selected-left">
              ${getSidebarMedia(item)}
              <div class="c-bundle-builder__selected-info">
                <p class="c-bundle-builder__selected-title">${item.title}</p>
                <p class="c-bundle-builder__selected-price">${toCurrency(item.price)} x ${item.quantity}</p>
              </div>
            </div>
            <button type="button" class="c-bundle-builder__remove" data-remove-variant="${item.variantId}" aria-label="Remove product">+</button>
          `;
          selectedList.appendChild(row);
        });

        const emptySlots = Math.max(0, Math.min(2, maxItems - selectedRows));
        for (let i = 0; i < emptySlots; i += 1) {
          const empty = document.createElement('div');
          empty.className = 'c-bundle-builder__empty-item';
          empty.innerHTML = `
            <span class="c-bundle-builder__empty-image">+</span>
            <p class="c-bundle-builder__empty-text">Agrega productos</p>
          `;
          emptyList.appendChild(empty);
        }

        const percent = maxItems > 0 ? Math.round((selectedUnits / maxItems) * 100) : 0;
        selectedCountNode.textContent = String(selectedUnits);
        progressPercentNode.textContent = String(percent);
        progressFill.style.width = Math.min(percent, 100) + '%';
        addAllButton.disabled = selectedUnits === 0;
      };

      const createSwiper = () => {
        if (!swiperElement || !paginationElement || !prevElement || !nextElement) return;
        if (swiper) return;

        swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
          speed: 450,
          watchOverflow: true,
          loop: false,
          pagination: {
            el: paginationElement,
            clickable: true
          },
          navigation: {
            prevEl: prevElement,
            nextEl: nextElement
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              grid: {
                rows: 1,
                fill: 'row'
              },
              spaceBetween: 24
            },
            978: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 24,
              grid: {
                rows: 2,
                fill: 'row'
              }
            }
          }
        });

        swiper.on('slideChange', () => {
          if (!activeTab) return;
          tabIndexByCollection.set(activeTab, swiper.activeIndex);
        });
      };

      const rebuildSwiper = () => {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
        createSwiper();
      };

      const syncView = (forceRebuild = false, resetToFirstSlide = false, preserveCurrentPage = true, preferredIndex = null) => {
        const previousIndex = swiper ? swiper.activeIndex : 0;

        renderActiveSlides();

        tabs.forEach((tab) => {
          const isActive = tab.dataset.tabTag === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        updateCardState();
        renderSidebar();

        if (forceRebuild) {
          rebuildSwiper();
        }
        if (swiper) {
          swiper.update();
          let targetIndex = null;

          if (resetToFirstSlide) {
            targetIndex = 0;
          } else if (preserveCurrentPage) {
            if (typeof preferredIndex === 'number') {
              targetIndex = preferredIndex;
            } else if (tabIndexByCollection.has(activeTab)) {
              targetIndex = tabIndexByCollection.get(activeTab);
            } else {
              targetIndex = previousIndex;
            }
          }

          if (typeof targetIndex === 'number') {
            const maxIndex = Math.max(0, swiper.slides.length - 1);
            const clampedTarget = Math.min(targetIndex, maxIndex);
            swiper.slideTo(clampedTarget, 0);
            if (activeTab) {
              tabIndexByCollection.set(activeTab, clampedTarget);
            }
          }
        }
      };

      const addOne = (node) => {
        const variantId = node.dataset.variantId;
        const title = node.dataset.title || '';
        const price = Number(node.dataset.price || 0);
        const image = node.dataset.image || '';

        if (!variantId || !title) return;

        const existing = selected.get(variantId);
        if (existing) {
          if (!canIncrease()) return;
          existing.quantity += 1;
          selected.set(variantId, existing);
        } else {
          if (!canIncrease()) return;
          selected.set(variantId, {
            variantId,
            title,
            price,
            image,
            quantity: 1
          });
        }

        syncView();
      };

      const decreaseOne = (node) => {
        const variantId = node.dataset.variantId;
        if (!variantId) return;

        const existing = selected.get(variantId);
        if (!existing) return;

        existing.quantity -= 1;
        if (existing.quantity <= 0) {
          selected.delete(variantId);
        } else {
          selected.set(variantId, existing);
        }

        syncView();
      };

      section.addEventListener('click', async (event) => {
        const tab = event.target.closest('[data-bundle-tab]');
        if (tab) {
          const nextTab = tab.dataset.tabTag || activeTab;
          if (nextTab === activeTab) return;

          if (swiper && activeTab) {
            tabIndexByCollection.set(activeTab, swiper.activeIndex);
          }

          activeTab = nextTab;
          const rememberedIndex = tabIndexByCollection.get(activeTab) ?? 0;
          syncView(true, false, true, rememberedIndex);
          return;
        }

        const removeButton = event.target.closest('[data-remove-variant]');
        if (removeButton) {
          selected.delete(removeButton.dataset.removeVariant || '');
          syncView();
          return;
        }

        const actionButton = event.target.closest('[data-action]');
        if (actionButton) {
          const action = actionButton.dataset.action;
          const card = actionButton.closest('[data-bundle-product]');
          if (!card) return;

          if (action === 'add' || action === 'increase') {
            addOne(card);
            return;
          }

          if (action === 'decrease') {
            decreaseOne(card);
            return;
          }
        }

        const addAll = event.target.closest('[data-add-all]');
        if (addAll) {
          const items = Array.from(selected.values()).map((item) => ({
            id: Number(item.variantId),
            quantity: Number(item.quantity)
          }));

          if (!items.length) return;

          addAll.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            });

            if (!response.ok) {
              throw new Error('Unable to add bundle to cart');
            }

            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: section.dataset.sectionId,
                  data: { source: 'bundle-builder' }
                }
              })
            );

            window.location.href = '/cart';
          } catch (error) {
            console.error(error);
            addAll.disabled = false;
          }
        }
      });

      const onResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const rememberedIndex = tabIndexByCollection.get(activeTab) ?? (swiper ? swiper.activeIndex : 0);
          syncView(true, false, true, rememberedIndex);
        }, 120);
      };

      createSwiper();
      syncView(true, true);
      window.addEventListener('resize', onResize);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId !== section.dataset.sectionId) return;
        window.removeEventListener('resize', onResize);
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-bundle-static"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.c-bundle-showcase');

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-bundle-tab]'));
      const sourceContainer = document.getElementById(`c-bundle-source-${section.dataset.sectionId}`);
      const productNodes = Array.from(sourceContainer.querySelectorAll('[data-bundle-product]'));
      
      let activeTab = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.tabTag || tabs[0]?.dataset.tabTag || '';
      const productsMap = new Map();
      let swiperInstances = [];

      productNodes.forEach((node) => {
        const key = `${node.dataset.tabTag}-${node.dataset.tier}`;
        if (!productsMap.has(key)) productsMap.set(key, []);
        productsMap.get(key).push(node);
      });

      const initSwipers = () => {
        const swiperContainers = section.querySelectorAll('.swiper');
        swiperContainers.forEach(container => {
          const tierWrap = container.closest('[data-tier-container]');
          const prevEl = tierWrap.querySelector('[data-products-prev]');
          const nextEl = tierWrap.querySelector('[data-products-next]');
          const paginationEl = tierWrap.querySelector('.swiper-pagination');
          
          const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 450,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
            pagination: {
              el: paginationEl,
              clickable: true
            },
            breakpoints: {
              768: { slidesPerView: 2.3, spaceBetween: 20 },
              978: { slidesPerView: 3.2, spaceBetween: 24 },
              1200: { slidesPerView: 3.5, spaceBetween: 24 }
            }
          });
          swiperInstances.push({ id: tierWrap.dataset.tierContainer, swiper });
        });
      };

      const renderActiveSlides = () => {
        const tiers = ['basico', 'premium'];
        tiers.forEach(tier => {
          const container = section.querySelector(`[data-tier-container="${tier}"]`);
          const wrapper = container?.querySelector('.swiper-wrapper');
          if (!wrapper || !container) return;

          const slides = productsMap.get(`${activeTab}-${tier}`) || [];
          wrapper.innerHTML = '';
          
          if (slides.length > 0) {
            container.style.display = 'flex';
            slides.forEach(slide => {
              slide.hidden = false;
              wrapper.appendChild(slide);
            });
          } else {
            container.style.display = 'none';
          }
        });

        swiperInstances.forEach(inst => {
          inst.swiper.update();
          inst.swiper.slideTo(0, 0);
        });
      };

      const syncView = () => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.tabTag === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });
        renderActiveSlides();
      };

      section.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-bundle-tab]');
        if (tab) {
          const nextTab = tab.dataset.tabTag || activeTab;
          if (nextTab !== activeTab) {
            activeTab = nextTab;
            syncView();
          }
        }
      });

      initSwipers();
      syncView();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-carrusel-v2"] && !Shopify.designMode) return;
  try {
    
  function initCarruselV2() {
    const sections = document.querySelectorAll('.c-carrusel-v2');
    sections.forEach((section) => {
      const swiperEl = section.querySelector('.c-carrusel-v2__swiper');
      if (!swiperEl || typeof window.Swiper === 'undefined') return;

      const prevBtn = section.querySelector('.c-carrusel-v2__prev');
      const nextBtn = section.querySelector('.c-carrusel-v2__next');

      const manageSwiper = () => {
        if (window.innerWidth < 978) {
          if (!swiperEl.swiper) {
            new window.Swiper(swiperEl, {
              slidesPerView: 1.25, // Efecto peek en mobile
              spaceBetween: 16,
              slidesOffsetAfter: 20,
              grabCursor: true,
              navigation: { prevEl: prevBtn, nextEl: nextBtn },
              breakpoints: { 768: { slidesPerView: 2.2, spaceBetween: 24 } }
            });
          }
        } else if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
      };

      manageSwiper();
      window.addEventListener('resize', manageSwiper);
    });
  }
  document.addEventListener('DOMContentLoaded', initCarruselV2);
  document.addEventListener('shopify:section:load', initCarruselV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-collection-filters"] && !Shopify.designMode) return;
  try {
    
  // In a real implementation, this would connect to Shopify's filter system
  // For now, this is a static UI component
  
  document.addEventListener('DOMContentLoaded', function() {
    const closeButtons = document.querySelectorAll('.c-collection-filters__pill-close');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Remove the parent pill
        this.closest('.c-collection-filters__pill').remove();
        
        // Check if any pills remain, hide clear all if none
        const remainingPills = document.querySelectorAll('.c-collection-filters__pill');
        if (remainingPills.length === 0) {
          const clearButton = document.querySelector('.c-collection-filters__clear');
          if (clearButton) clearButton.style.display = 'none';
        }
      });
    });
    
    const clearAllButton = document.querySelector('.c-collection-filters__clear');
    if (clearAllButton) {
      clearAllButton.addEventListener('click', function() {
        const pills = document.querySelectorAll('.c-collection-filters__pill');
        pills.forEach(pill => pill.remove());
        this.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-contact-extended"] && !Shopify.designMode) return;
  try {
    
// No requiere JS personalizado

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-content-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.c-content-tabs').forEach(function (section) {
      const tabs = section.querySelectorAll('.c-content-tabs__tab');
      const panels = section.querySelectorAll('.c-content-tabs__content');
      const dots = section.querySelectorAll('.c-content-tabs__dot');

      function activateTab(index) {
        tabs.forEach(function (tab, i) {
          const isActive = i + 1 === index;
          tab.classList.toggle('c-content-tabs__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel, i) {
          const isActive = i + 1 === index;
          panel.classList.toggle('c-content-tabs__content--active', isActive);
          panel.hidden = !isActive;
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('c-content-tabs__dot--active', i + 1 === index);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const index = parseInt(tab.dataset.tabIndex, 10);
          activateTab(index);
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const index = parseInt(dot.dataset.dotIndex, 10);
          activateTab(index);
        });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('keydown', function (e) {
          const currentIndex = parseInt(tab.dataset.tabIndex, 10);
          let newIndex;

          if (e.key === 'ArrowRight') {
            newIndex = currentIndex < tabs.length ? currentIndex + 1 : 1;
          } else if (e.key === 'ArrowLeft') {
            newIndex = currentIndex > 1 ? currentIndex - 1 : tabs.length;
          } else if (e.key === 'Home') {
            newIndex = 1;
          } else if (e.key === 'End') {
            newIndex = tabs.length;
          }

          if (newIndex) {
            e.preventDefault();
            activateTab(newIndex);
            tabs[newIndex - 1].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-guides-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('[data-guides-swiper]');
    
    if (swiperElement && typeof Swiper !== 'undefined') {
      new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: '.c-guides-grid__pagination',
          clickable: true,
        },
        breakpoints: {
          978: {
            enabled: false,
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-guides"] && !Shopify.designMode) return;
  try {
    
  function initCGuidesSwiper() {
    const sections = document.querySelectorAll('.c-guides');

    sections.forEach((section) => {
      const swiperEl = section.querySelector('.c-guides__swiper');
      if (!swiperEl) return;

      const prevBtn = section.querySelector('.c-guides__prev');
      const nextBtn = section.querySelector('.c-guides__next');

      if (typeof window.Swiper === 'undefined') return;

      const updateActiveCardClass = (swiper) => {
        const slides = swiper.slides;
        slides.forEach((slide, index) => {
          const card = slide.querySelector('.c-guides__card');
          if (!card) return;

          if (index === swiper.activeIndex) {
            card.classList.remove('c-guides__card--inactive');
          } else {
            card.classList.add('c-guides__card--inactive');
          }
        });
      };

      const options = {
        slidesPerView: 1.15,
        centeredSlides: true,
        spaceBetween: 12,
        speed: 500,
        grabCursor: true,
        watchOverflow: true,
        loop: false,

        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },

        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 16,
            centeredSlides: true,
          },
          978: {
            slidesPerView: 3,
            spaceBetween: 21,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 21,
            centeredSlides: true,
          },
        },

        on: {
          init: function () {
            updateActiveCardClass(this);
          },
          slideChange: function () {
            updateActiveCardClass(this);
          },
        },
      };

      if (swiperEl.swiper) {
        const s = swiperEl.swiper;
        s.params.navigation = s.params.navigation || {};
        s.params.navigation.prevEl = prevBtn;
        s.params.navigation.nextEl = nextBtn;

        if (s.navigation) {
          s.navigation.destroy();
          s.navigation.init();
          s.navigation.update();
        }

        s.update();
        updateActiveCardClass(s);
        return;
      }

      new window.Swiper(swiperEl, options);
    });
  }

  document.addEventListener('DOMContentLoaded', initCGuidesSwiper);
  document.addEventListener('shopify:section:load', initCGuidesSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-v2"] && !Shopify.designMode) return;
  try {
    
  // Add any specific JavaScript functionality for the hero section here
  // Example: intersection observer for animations, parallax effects, etc.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-how-we-work-ruster"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.c-how-we-work-ruster');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      let stepsSwiper = null;
      let resizeTimeout = null;

      const buildSwiper = () => {
        const swiperElement = section.querySelector('[data-steps-swiper]');
        const paginationElement = section.querySelector('[data-steps-pagination]');

        if (!swiperElement || !paginationElement) return;

        const isMobile = window.matchMedia('(max-width: 977px)').matches;

        if (isMobile && !stepsSwiper) {
          stepsSwiper = new Swiper(swiperElement, {
            slidesPerView: 1.08,
            spaceBetween: 32,
            speed: 450,
            watchOverflow: true,
            pagination: {
              el: paginationElement,
              clickable: true
            },
            breakpoints: {
              768: {
                slidesPerView: 1.5,
                spaceBetween: 32
              }
            }
          });
        }

        if (!isMobile && stepsSwiper) {
          stepsSwiper.destroy(true, true);
          stepsSwiper = null;
        }
      };

      const onResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(buildSwiper, 120);
      };

      buildSwiper();
      window.addEventListener('resize', onResize);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId !== section.dataset.sectionId) return;
        window.removeEventListener('resize', onResize);
        if (stepsSwiper) {
          stepsSwiper.destroy(true, true);
          stepsSwiper = null;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-objective-tabs-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initObjectiveSection(section) {
      if (!section) return;

      const tabs = Array.from(section.querySelectorAll('.c-objective-tabs-products__tab'));
      const panels = Array.from(section.querySelectorAll('.c-objective-tabs-products__panel'));

      if (!tabs.length || !panels.length) return;

      function setupSwiper(panel) {
        if (!panel) {
          return;
        }

        const swiperElement = panel.querySelector('[data-objective-swiper]');
        const paginationElement = panel.querySelector('[data-objective-pagination]');
        const prevElement = panel.querySelector('[data-objective-prev]');
        const nextElement = panel.querySelector('[data-objective-next]');
        const variant = swiperElement ? swiperElement.dataset.swiperVariant : 'product';

        if (!swiperElement || typeof Swiper === 'undefined') return;

        const initializedVariant = panel.dataset.swiperVariantInitialized;

        if (panel._objectiveSwiper && initializedVariant && initializedVariant !== variant) {
          panel._objectiveSwiper.destroy(true, true);
          panel._objectiveSwiper = null;
          panel.dataset.swiperReady = 'false';
        }

        if (panel.dataset.swiperReady === 'true' && panel._objectiveSwiper) {
          panel._objectiveSwiper.update();
          return;
        }

        const productBreakpoints = {
          768: {
            slidesPerView: 1.05,
            spaceBetween: 16
          },
          978: {
            slidesPerView: 1.65,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 1.9,
            spaceBetween: 24
          },
          1980: {
            slidesPerView: 2.2,
            spaceBetween: 28
          }
        };

        const setupBreakpoints = {
          768: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          978: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1200: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1980: {
            slidesPerView: 2,
            spaceBetween: 24
          }
        };

        panel._objectiveSwiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 16,
          speed: 450,
          watchOverflow: true,
          pagination: {
            el: paginationElement,
            clickable: true
          },
          navigation: {
            prevEl: prevElement,
            nextEl: nextElement
          },
          breakpoints: variant === 'setup' ? setupBreakpoints : productBreakpoints
        });

        panel.dataset.swiperReady = 'true';
        panel.dataset.swiperVariantInitialized = variant;
      }

      function activateTab(index) {
        tabs.forEach(function (tab, tabIndex) {
          const isActive = tabIndex === index;
          tab.classList.toggle('c-objective-tabs-products__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel, panelIndex) {
          const isActive = panelIndex === index;
          panel.classList.toggle('c-objective-tabs-products__panel--active', isActive);
          panel.hidden = !isActive;

          if (isActive) {
            setupSwiper(panel);
            if (panel._objectiveSwiper) {
              panel._objectiveSwiper.update();
            }
          }
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(index);
        });

        tab.addEventListener('keydown', function (event) {
          let nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = index + 1 >= tabs.length ? 0 : index + 1;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(nextIndex);
            tabs[nextIndex].focus();
          }
        });
      });

      activateTab(0);
    }

    function initAllObjectiveSections(root) {
      const scope = root || document;
      const sections = scope.querySelectorAll('.c-objective-tabs-products');
      sections.forEach(initObjectiveSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllObjectiveSections(document);
      });
    } else {
      initAllObjectiveSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllObjectiveSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-quote-form"] && !Shopify.designMode) return;
  try {
    
// No requiere JS personalizado

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-review-scroll"] && !Shopify.designMode) return;
  try {
    
  function initReviewScroll() {
    const sections = document.querySelectorAll('.c-review-scroll');

    sections.forEach((section) => {
      const swiperEl = section.querySelector('.c-review-scroll__swiper');
      if (!swiperEl) return;

      const prevBtn = section.querySelector('.c-review-scroll__prev');
      const nextBtn = section.querySelector('.c-review-scroll__next');

      if (typeof window.Swiper === 'undefined') return;

      const options = {
        slidesPerView: 1.15,
        centeredSlides: false,
        spaceBetween: 0,
        speed: 500,
        grabCursor: true,
        watchOverflow: true,

        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },

        breakpoints: {
          768: { slidesPerView: 2.2, spaceBetween: 0 },
          978: { slidesPerView: 3.15, spaceBetween: 0 },
          1200: { slidesPerView: 4.15, spaceBetween: 0 },
        },
      };

      if (swiperEl.swiper) {
        const s = swiperEl.swiper;

        s.params.navigation = s.params.navigation || {};
        s.params.navigation.prevEl = prevBtn;
        s.params.navigation.nextEl = nextBtn;

        if (s.navigation) {
          s.navigation.destroy();
          s.navigation.init();
          s.navigation.update();
        }

        s.update();
        return;
      }

      new window.Swiper(swiperEl, options);

      // Video play/pause functionality
      const videoCards = section.querySelectorAll('.c-review-card--media');
      videoCards.forEach((card) => {
        const video = card.querySelector('video');
        const playBtn = card.querySelector('.c-review-card__play-btn');
        const mediaWrapper = card.querySelector('.c-review-card__media-wrapper');

        if (video && playBtn) {
          const setPlayingState = (isPlaying) => {
            if (mediaWrapper) {
              mediaWrapper.classList.toggle('is-playing', isPlaying);
            }
            playBtn.classList.toggle('is-hidden', isPlaying);
          };

          playBtn.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              setPlayingState(true);
            } else {
              video.pause();
              setPlayingState(false);
            }
          });

          video.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              setPlayingState(true);
            } else {
              video.pause();
              setPlayingState(false);
            }
          });

          video.addEventListener('play', () => setPlayingState(true));
          video.addEventListener('pause', () => setPlayingState(false));

          video.addEventListener('ended', () => {
            setPlayingState(false);
          });

          setPlayingState(!video.paused);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initReviewScroll);
  document.addEventListener('shopify:section:load', initReviewScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const syncStickyQuantity = (sticky) => {
      if (!sticky) return 1;

      const stickyInput = sticky.querySelector('.qty-input-field');
      if (!(stickyInput instanceof HTMLInputElement)) return 1;

      const parsed = parseInt(stickyInput.value || '1', 10);
      const quantity = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;

      stickyInput.value = quantity.toString();
      sticky.dataset.stickyQuantity = quantity.toString();

      const quantityNumber = sticky.querySelector('[ref="quantityNumber"]');
      const quantityDisplay = sticky.querySelector('[ref="quantityDisplay"]');
      if (quantityNumber) quantityNumber.textContent = quantity.toString();
      if (quantityDisplay instanceof HTMLElement) {
        quantityDisplay.style.display = quantity > 1 ? 'inline' : 'none';
      }

      return quantity;
    };

    // Handle qty-btn-plus increment directly on the sticky bar.
    // The add-to-cart button is handled by the sticky-add-to-cart component directly.
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const addButton = target.closest('.sticky-bar-add-button');
        if (addButton) {
          const sticky = addButton.closest('sticky-add-to-cart');
          if (!sticky) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          // Ensure quantity is normalized and synced before add request.
          syncStickyQuantity(sticky);

          // Fallback delegation: ensure the sticky component add flow executes.
          if (typeof sticky.handleAddToCartClick === 'function') {
            sticky.handleAddToCartClick(event);
          }
          return;
        }

        const plusButton = target.closest('.qty-btn-plus');
        if (!plusButton) return;

        const sticky = plusButton.closest('sticky-add-to-cart');
        if (!sticky) return;

        event.preventDefault();

        const stickyInput = sticky.querySelector('.qty-input-field');
        if (!(stickyInput instanceof HTMLInputElement)) return;

        const current = parseInt(stickyInput.value || '1', 10) || 1;
        const next = current + 1;
        stickyInput.value = next.toString();

        syncStickyQuantity(sticky);
      },
      true
    );

    document.addEventListener(
      'input',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const stickyInput = target.closest('.qty-input-field');
        if (!stickyInput) return;

        const sticky = stickyInput.closest('sticky-add-to-cart');
        if (!sticky) return;

        syncStickyQuantity(sticky);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
